import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from './../../../environments/environment';

// import ngx-translate and the http loader
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '../forms/forms.module';
import { AddressCompletionModule } from '../address-completion/address-completion.module';

// Shared Angular Material Components
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatMomentDateModule,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { OverlayModule } from '@angular/cdk/overlay'
import { MaterialFileInputModule } from 'ngx-custom-material-file-input';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { DialogConfirmationComponent } from './services/dialog.service';

import { ImageSelectorComponent } from './components/image-selector/image-selector.component';
import { StepperButtonsComponent } from './components/stepper-buttons/stepper-buttons.component';
import { FormSendComponent } from './components/form-send/form-send.component';
import { PersonalInformationComponent } from './components/personal-information/personal-information.component';
import { IdentificationProviderComponent } from './components/identification-provider/identification-provider.component';
import { IdentificationLMSProviderComponent } from './components/identification-lms-provider/identification-lms-provider.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { CaptchaComponent } from './components/captcha/captcha.component';
import { EidFormSendComponent } from './components/eid-form-send/eid-form-send.component';
import { EmailVerificationComponent } from './components/email-verification/email-verification.component';
import { IdentificationComponent } from './components/identification/identification.component';
import { IdentificationCardComponent } from './components/identification-card/identification-card.component';

import { TooltipRendererDirective } from './directives/tooltip-renderer.directive';

import { AsPipe } from './pipes/as.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { JoinPipe } from './pipes/join.pipe';
import { I18nEnumPipe } from './pipes/i18n-enum.pipe';

const DATE_FORMAT = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    AsPipe,
    SafePipe,
    JoinPipe,
    I18nEnumPipe,
    ImageSelectorComponent,
    StepperButtonsComponent,
    DialogConfirmationComponent,
    FormSendComponent,
    PersonalInformationComponent,
    IdentificationProviderComponent,
    IdentificationLMSProviderComponent,
    TooltipComponent,
    CaptchaComponent,
    EidFormSendComponent,
    EmailVerificationComponent,
    IdentificationComponent,
    IdentificationCardComponent,
    TooltipRendererDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatRadioModule,
    MatStepperModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatSelectModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatCardModule,
    MatDialogModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    NgxMaskDirective, 
    NgxMaskPipe,
    OverlayModule,
    MaterialFileInputModule,
    AddressCompletionModule.forRoot({
      webServiceUrl: environment.apiBaseUrl + '/address',
    }),
  ],
  exports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatRadioModule,
    MatStepperModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatSelectModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatCardModule,
    MatDialogModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    NgxMaskDirective, 
    NgxMaskPipe,
    OverlayModule,
    MaterialFileInputModule,
    AddressCompletionModule,
    AsPipe,
    SafePipe,
    JoinPipe,
    I18nEnumPipe,
    ImageSelectorComponent,
    StepperButtonsComponent,
    FormSendComponent,
    PersonalInformationComponent,
    IdentificationProviderComponent,
    IdentificationLMSProviderComponent,
    TooltipComponent,
    CaptchaComponent,
    EidFormSendComponent,
    EmailVerificationComponent,
    IdentificationComponent,
    IdentificationCardComponent,
    TooltipRendererDirective,
  ],
  providers: [
    provideNgxMask(),
    MatNativeDateModule,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false, showError: true },
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    {
      provide: MAT_DATE_FORMATS,
      useValue: DATE_FORMAT,
    },
  ],
})
export class SharedModule {}
